import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { catchError, EMPTY } from 'rxjs';
import { PAGE } from '../core';
import { UserService } from '../services';
import { BaseComponent, ConvertDatePipe } from '../shared';
import { DashboardCalendarComponent } from './dashboard-calendar';
import { DashboardEventsComponent } from './dashboard-events';
import { DashboardFiltersComponent } from './dashboard-filters';


/**
* Component for dashboard page.
*/
@Component({
	selector: 'app-dashboard',
	templateUrl: './dashboard.component.html',
	imports: [
		DatePipe,
		ConvertDatePipe,
		DashboardEventsComponent,
		DashboardFiltersComponent,
		DashboardCalendarComponent
	],
	changeDetection: ChangeDetectionStrategy.Eager
})
export class DashboardComponent extends BaseComponent {

	private readonly router = inject(Router);
	private readonly userSrv = inject(UserService);

	isCalendarVisible = toSignal(this.userSrv.isTlhex());
	signin = toSignal(this.userSrv.getLastSignIn().pipe(catchError(err => {
		console.error(err.message);
		return EMPTY;
	})));

	/**
	* Navigate to patient creation page.
	*/
	createPatient(): void {
		this.router.navigateByUrl(`/${PAGE.PATIENT_NEW}`);
	}

	/**
	* Navigate to patient list.
	*/
	searchPatient(): void {
		this.router.navigateByUrl(`/${PAGE.LIST_PLANS}`);
	}

}
